import { readViteEnv } from "./viteEnv";
export interface FeatureFlag {
  id: string;
  name: string;
  active: boolean;
}

/**
 * Registro de flags. Vazio: `api-v2` e `api-v2-auth` sairam na limpeza da Fase 9
 * (AB#81972) — a `apps/api-legacy` deixou o monorepo, entao o ramo desligado
 * apontava para caminhos que nao existem mais. O mecanismo fica de pe como ponto
 * de extensao para a proxima flag.
 */
export const FEATURE_FLAGS = {} as const;

/**
 * Feature flags são resolvidas SÓ por env do web — não há mais consulta ao DB.
 * Cada flag mapeia pra uma env var `VITE_*` lida no mesmo padrão do `api.ts`
 * (`window.ENV` em runtime > `import.meta.env` em build-time). Valor `'true'`
 * liga a flag; qualquer outra coisa (ou ausência) deixa desligada.
 */
const FLAG_ENV: Record<string, string> = {};

// A referência a `import.meta.env` precisa ser ESTÁTICA: é ela que faz o Vite
// injetar o objeto de env no módulo. Escrita como acesso dinâmico
// (`(import.meta as any)?.env`) a injeção não acontecia e toda flag era lida
// como undefined — ou seja, nenhuma flag surtia efeito no browser.
// O tipo de `import.meta.env` vem de `src/vite-env.d.ts`, sem assertion.
function readEnv(name: string): string | undefined {
  if (typeof window !== "undefined" && window.ENV?.[name])
    return window.ENV[name];
  return readViteEnv(name);
}

/** Resolve uma flag pelo nome lógico via env do web. Default OFF. */
export function isFeatureFlagEnabled(name: string): boolean {
  const envVar = FLAG_ENV[name];
  if (!envVar) return false;
  return readEnv(envVar) === "true";
}
